import { EndorsementPremiumChange } from '@root/@types/types';

export const ENDORSEMENT_TYPES = ['Cancellation', 'Endorsement', 'Void from Inception'] as const;

export const ENDORSEMENT_REASONS = [
  'Product unsuitable or misunderstood',
  'Product too expensive',
  'Alternative product purchased',
  'Cover overlapped with pre-existing cover',
  'Product cancelled within cooling off period',
  'Product cancelled by underwriter',
  'Poor service or complaint',
  'Cover no longer required',
  'New Address',
  'Addition or Deletion of Sections',
  'Change to Annual Aggregate Limit',
  'Change to Building Sum Insured',
  'Change to Contents Sum Insured',
  'Other Reasons',
  'Not Known',
] as const;

export const ENDORSEMENT_PREMIUM_CHANGES = Object.values(EndorsementPremiumChange);
